import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast.
const page = <K extends string>(load: () => Promise<Record<K, React.ComponentType>>, name: K) => lazy(() => load().then((m) => ({ default: m[name] })));
const PeoplePage = page(() => import("./web/PeoplePage.js"), "PeoplePage");
const PersonPage = page(() => import("./web/PersonPage.js"), "PersonPage");
const MePage = page(() => import("./web/MePage.js"), "MePage");
const LeavePage = page(() => import("./web/LeavePage.js"), "LeavePage");
const RotaPage = page(() => import("./web/RotaPage.js"), "RotaPage");
const TimePage = page(() => import("./web/TimePage.js"), "TimePage");
const ExpensesPage = page(() => import("./web/ExpensesPage.js"), "ExpensesPage");
const SettingsPage = page(() => import("./web/SettingsPage.js"), "SettingsPage");

export default defineWebModule({
  manifest,
  pages: {
    "": PeoplePage,
    "/person": PersonPage,
    "/me": MePage,
    "/leave": LeavePage,
    "/rota": RotaPage,
    "/time": TimePage,
    "/expenses": ExpensesPage,
    "/settings": SettingsPage,
  },
});
